import {
  LOGOUT,
  USER_ROLE_RECEIVED,
  COMPANY_LIST_RECEIVED,
  CHANGE_LANGUAGE,
  LIST_LANGUAGES,
  ADD_ACTIVE_PAGE,
  RECEIVE_APP_PROPS,
  EQUIPMENT_IOT_DATA_RECEIVED,
  EQUIPMENT_IOT_DATA_LOADING,
  EQUIPMENT_IOT_DATA_ERROR,
  RESET_IOT_DATA,
  ADD_KEN_LINK,
  REMOVE_KEN_LINK,
  REMOVE_ALL,
  ADD_FLOW,
  STORE_KEN_NUMBER,
  STORE_SO_NUMBER,
  UPDATE_COLLECTED_DATA,
  FORM_UPLOAD_FAILED,
  ADD_CANCELLATION_TOKEN,
  REMOVE_CANCELLATION_TOKEN,
  SET_IMAGE_UPLOAD_STATUS,
  SELECT_CLINICA_FORM,
  SELECT_SITE_SURVEY_FORM,
  ADD_SURVEY_ID,
  INIT_LOGGED_IN,
  EMAIL_SEND_STATUS,
  PDF_GEN_STATUS,
  STORE_CSRF_TOKEN,
  SYSTEM_DOWNTIME_NOTIFICATION,
  SYSTEM_DOWNTIME_NOTIFICATION_SEEN,
  DISPLAY_SITE_SURVEY_BANNER,
  DISPLAY_SITE_SURVEY_ALERT,
  SHOULD_DISPLAY_SITE_SURVEY_ALERT,
  INTERNET_STATUS,
  PENDING_TO_START_SURVEY,
  PREVIOUS_SITE_SURVEY_DATA_LOADING,
  PREVIOUS_SITE_SURVEY_DATA_RECEIVED,
  PREVIOUS_SITE_SURVEY_DATA_ERROR,
} from './application_actions';

import { combineReducers } from 'redux';
import axios from 'axios';
import authService from './services/auth'

const I18N_INITIAL_STATE = {
  availableLanguages: {
    "en": "English"
  },
  language: localStorage.getItem('preferredLanguage') || "en",
  strings: JSON.parse(localStorage.getItem('translation')) || {
    Login: {
      title: "",
      SSOButton: "Login with SSO",
      chooseLanguage: "Choose Language"
    }
  }
};

function i18nReducer(state = I18N_INITIAL_STATE, action) {

  switch (action.type) {

    case CHANGE_LANGUAGE: {
      localStorage.setItem('translation', JSON.stringify(action.payload.trans));
      localStorage.setItem('preferredLanguage', action.payload.lang)
      return Object.assign({}, state, {
        language: action.payload.lang,
        strings: action.payload.trans,
      });
    }

    case LIST_LANGUAGES: {
      return Object.assign({}, state, {
        availableLanguages: action.payload
      });
    }

    default:
      return state;
  }
}

const AUTH_INITIAL_STATE = {
  isLoggedIn: undefined, // at this moment not in use
  allowedCompanies: undefined,
  roleAllowed: undefined
};

function authReducer(state = AUTH_INITIAL_STATE, action) {

  switch (action.type) {
    case USER_ROLE_RECEIVED: {
      return Object.assign({}, state, {
        roleAllowed: action.payload
      });
    }

    case COMPANY_LIST_RECEIVED: {
      return Object.assign({}, state, {
        allowedCompanies: action.payload,
      });
    }

    case LOGOUT: {
      return Object.assign({}, state, {
        isLoggedIn: false
      });
    }

    case INIT_LOGGED_IN: {
      return Object.assign({}, state, {
        isLoggedIn: action.payload
      });
    }

    case STORE_CSRF_TOKEN: {
      return Object.assign({}, state, {
        csrfToken: action.payload
      });
    }

    default:
      return state;
  }
}

const PROGRESS_INITIAL_STATE = {
  active: undefined,
  currentIndex: -1,
  flow: []
};

function progressReducer(state = PROGRESS_INITIAL_STATE, action) {

  switch (action.type) {

    case ADD_ACTIVE_PAGE: {
      const index = state.flow.findIndex((item) => {
        return item.name === action.payload
      });
      return Object.assign({}, state, {
        activePage: action.payload,
        currentIndex: index
      });
    }
    case ADD_FLOW: {
      return Object.assign({}, state, {
        flow: action.payload
      });
    }

    default:
      return state;
  }
}

const APP_INITIAL_STATE = {
  kenLink: undefined,
  form: {},
  collectedData: {},
  internetStatus: true,
  pendingToStartSurvey: undefined,
  siteSurveyForm: 'ELEVATOR'
};

function appReducer(state = APP_INITIAL_STATE, action) {

  switch (action.type) {

    case SYSTEM_DOWNTIME_NOTIFICATION_SEEN: {
      
      var newData = state.systemDowntime.map((object) => {
        if (object?.id === action.payload) {
          return { ...object, seen: true, seenDate: new Date() };
        }
        return object;
      });

      localStorage.setItem('systemDowntimeNotification', JSON.stringify(newData));

      return Object.assign({}, state, {
        systemDowntime: newData
      });
    }

    case SYSTEM_DOWNTIME_NOTIFICATION: {

      return Object.assign({}, state, {
        systemDowntime: action.payload
      });
    }

    case SELECT_CLINICA_FORM: {

      return Object.assign({}, state, {
        clinicaForm: action.payload
      });
    }

    case SELECT_SITE_SURVEY_FORM: {
      return Object.assign({}, state, {
        siteSurveyForm: action.payload
      });
    }

    case ADD_CANCELLATION_TOKEN: {
      const { formName, fieldName, imageId, token } = action.payload;
      
      const formData = state.collectedData?.[formName];
      const fieldData = formData?.[fieldName];

      if (!fieldData || !Array.isArray(fieldData.images)) {
        console.warn('ADD_CANCELLATION_TOKEN: Field or images not found for', formName, fieldName);
        return state; // Return current state unchanged
      }

      // Copy the image list and update the relevant image
      const updatedImages = fieldData.images.map(img =>
        img.imageId === imageId
          ? { ...img, cancel: token }
          : img
      );

      // Final updated state
      return {
        ...state,
        collectedData: {
          ...state.collectedData,
          [formName]: {
            ...formData,
            [fieldName]: {
              ...fieldData,
              images: updatedImages
            }
          }
        }
      };
    }

    case REMOVE_CANCELLATION_TOKEN: {
      const { formName, fieldName, imageId } = action.payload;

      const form = state.collectedData?.[formName];
      const field = form?.[fieldName];

      if (!field || !Array.isArray(field.images)) {
        return state; // No change if data path is invalid
      }

      // Create a new images array with the cancel token removed
      const updatedImages = field.images.map(item =>
        item.imageId === imageId
          ? (() => {
              const { cancel, ...rest } = item;
              return rest;
            })()
          : item
      );

      // Rebuild updated field and form
      const updatedField = {
        ...field,
        images: updatedImages
      };

      const updatedForm = {
        ...form,
        [fieldName]: updatedField
      };

      return {
        ...state,
        collectedData: {
          ...state.collectedData,
          [formName]: updatedForm
        }
      };
    }

    case PDF_GEN_STATUS: {

      return Object.assign({}, state, {
        pdfGenerated: action.payload,
      });
    }

    case EMAIL_SEND_STATUS: {

      return Object.assign({}, state, {
        emailSent: action.payload.emailsSent,
        failedEmails: action.payload.failedEmails
      });
    }

    case SET_IMAGE_UPLOAD_STATUS: {
      const { formName, fieldName, imageId, status, isRetry } = action.payload;

      const updatedImages = state.collectedData[formName][fieldName].images.map((item) => {
        if (item.imageId === imageId || imageId === 'all') {
          return {
            ...item,
            isRetry: isRetry,
            uploadSuccesfull: status,
          };
        }
        return item;
      });

      return {
        ...state,
        collectedData: {
          ...state.collectedData,
          [formName]: {
            ...state.collectedData[formName],
            [fieldName]: {
              ...state.collectedData[formName][fieldName],
              images: updatedImages,
            },
          },
        },
      };
    }

    case STORE_KEN_NUMBER: {
      return Object.assign({}, state, {
        KEN: action.payload,
      });
    }

    case STORE_SO_NUMBER: {
      return Object.assign({}, state, {
        SO: action.payload,
      });
    }

    case ADD_KEN_LINK: {
      return Object.assign({}, state, {
        kenLink: action.payload,
      });
    }

    case REMOVE_KEN_LINK: {
      return Object.assign({}, state, {
        kenLink: undefined
      });
    }

    case EQUIPMENT_IOT_DATA_RECEIVED: {
      return Object.assign({}, state, {
        iotData: action.payload,
        iotDataLoading: false,
      });
    }

    case EQUIPMENT_IOT_DATA_LOADING: {
      return Object.assign({}, state, {
        iotDataLoading: true,
      });
    }

    case EQUIPMENT_IOT_DATA_ERROR: {
      return Object.assign({}, state, {
        iotDataError: action.payload,
        iotDataLoading: false,
      });
    }

    case FORM_UPLOAD_FAILED: {
      return Object.assign({}, state, {
        formUploadError: action.payload,
      });
    }

    case RESET_IOT_DATA: {
      return Object.assign({}, state, {
        iotDataError: undefined,
        iotDataLoading: false,
        // iotData: undefined
      });
    }

    case UPDATE_COLLECTED_DATA: {

      return Object.assign({}, state, {
        collectedData: JSON.parse(JSON.stringify(action.payload)),
        formUploadError: null
      });
    }

    case ADD_SURVEY_ID: {
      const payload = JSON.parse(JSON.stringify(action.payload))
      return Object.assign({}, state, {
        surveyId: payload.surveyId,
        pdmSurveyId: payload.pdmSurveyId
      });
    }

    case REMOVE_ALL: {
      return Object.assign({}, state, APP_INITIAL_STATE);
    }

    case INTERNET_STATUS: {
      return Object.assign({},state,{ internetStatus: action.payload})
    }

    case PENDING_TO_START_SURVEY: {
      return Object.assign({},state,{ pendingToStartSurvey: action.payload})
    }

    case PREVIOUS_SITE_SURVEY_DATA_RECEIVED: {
      return Object.assign({}, state, {
        previousSiteSurveyData: action.payload,
        previousSiteSurveyLoading: false,
      });
    }

    case PREVIOUS_SITE_SURVEY_DATA_LOADING: {
      return Object.assign({}, state, {
        previousSiteSurveyLoading: true,
      });
    }

    case PREVIOUS_SITE_SURVEY_DATA_ERROR: {
      return Object.assign({}, state, {
        previousSiteSurveyData: null,
        previousSiteSurveyError: action.payload,
        previousSiteSurveyLoading: false,
      });
    }
 
    default:
      return state;
  }
}

const ENV_INITIAL_STATE = {};

function envReducer(state = ENV_INITIAL_STATE, action) {

  switch (action.type) {

    case RECEIVE_APP_PROPS: {
      return Object.assign({}, state, action.payload);
    }

    default:
      return state;
  }
};

const DISPLAY_SITE_SURVEY_ALERT_INITIAL_STATE = {
  displaySiteSurveyBanner: false,
  displaySiteSurveyAlert: false
};

function siteSurveyAlertBoxReducer(state = DISPLAY_SITE_SURVEY_ALERT_INITIAL_STATE, action) {
  switch (action.type) {
    case DISPLAY_SITE_SURVEY_ALERT: {
      return Object.assign({}, state, {
        displaySiteSurveyAlert: action.payload,
      });
    }

    case DISPLAY_SITE_SURVEY_BANNER : {
      return Object.assign({}, state, {
        displaySiteSurveyBanner: action.payload,
      });
    }

    default:
      return state
  }

}

export default combineReducers({
  i18n: i18nReducer,
  auth: authReducer,
  progress: progressReducer,
  app: appReducer,
  env: envReducer,
  siteSurveyAlert: siteSurveyAlertBoxReducer
});
